// Generated by purs version 0.13.8
"use strict";
var Animation_Core = require("../Animation.Core/index.js");
var Animation_Easing = require("../Animation.Easing/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Ring = require("../Data.Ring/index.js");
var Data_Semiring = require("../Data.Semiring/index.js");
var Data_Traversable = require("../Data.Traversable/index.js");
var Extra_Math = require("../Extra.Math/index.js");
var slide = function (startTime) {
    return function (duration) {
        return function (v) {
            var ease = Animation_Easing.ease(Data_Ring.sub(Animation_Easing.ringEasing)(Data_Semiring.add(Animation_Easing.semiringEasing)(Animation_Easing.h01)(Animation_Easing.mult(2.0)(Animation_Easing.h10)))(Animation_Easing.mult(1.0)(Animation_Easing.h11)));
            var f = function (x) {
                return Animation_Core.animate(startTime)(Animation_Core.singleton(duration)(function (v1) {
                    return ease(v1 / Data_Newtype.un(Animation_Core.newtypeDiffTime)(Animation_Core.DiffTime)(duration)) * x;
                }));
            };
            return Data_Traversable.traverse(Extra_Math.traversableVector)(Animation_Core.applicativeAnimating)(f)(v);
        };
    };
};
var reverseSlide = function (startTime) {
    return function (duration) {
        return function (v) {
            var ease = Animation_Easing.ease(Data_Ring.sub(Animation_Easing.ringEasing)(Data_Semiring.add(Animation_Easing.semiringEasing)(Animation_Easing.h00)(Animation_Easing.mult(1.0)(Animation_Easing.h11)))(Animation_Easing.mult(1.0)(Animation_Easing.h10)));
            var f = function (x) {
                return Animation_Core.animate(startTime)(Animation_Core.singleton(duration)(function (v1) {
                    return ease(v1 / Data_Newtype.un(Animation_Core.newtypeDiffTime)(Animation_Core.DiffTime)(duration)) * x;
                }));
            };
            return Data_Traversable.traverse(Extra_Math.traversableVector)(Animation_Core.applicativeAnimating)(f)(v);
        };
    };
};
var bump = function (startTime) {
    return function (duration) {
        return function (v) {
            var f = function (x) {
                return Animation_Core.animate(startTime)(Animation_Core.singleton(duration)(function (v1) {
                    return Animation_Easing.ease(Animation_Easing.h10)(v1 / Data_Newtype.un(Animation_Core.newtypeDiffTime)(Animation_Core.DiffTime)(duration)) * x;
                }));
            };
            return Data_Traversable.traverse(Extra_Math.traversableVector)(Animation_Core.applicativeAnimating)(f)(v);
        };
    };
};
module.exports = {
    slide: slide,
    bump: bump,
    reverseSlide: reverseSlide
};
